export default __webpack_public_path__ + "static/media/focus2big.c296879b.jpg";